import React, { Component } from "react"
import Slider from "react-slick"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../structured-text/custom-structured-text-renderer"
import { CloseCircle, Plus } from "../icons"
import FormComponent from "../form"
import AnimationButton from "../structured-text/blocks/animation-button"

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return <>{this.props.children}</>
  }
}

const ProductContent = (props) => {
  const [enquiry, setEnquiry] = React.useState(false)
  const [nutrition, setNutrition] = React.useState(false)
  const [directions, setDirections] = React.useState(false)

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    fade: true,
    autoplay: false,
  }

  let brandSlug = ""
  if (props.brand) {
    switch (props.brand) {
      case "bone":
        brandSlug = "bone-roasters"
        break
      case "greenwheat":
        brandSlug = "greenwheat-freekeh"
        break
      default:
        brandSlug = props.brand
    }
  }

  return (
    <>
      <section className={`product ${props.brand}`}>
        <div className="product__header">
          <div className="product__inner">
            {props.title && (
              <h1>{props.title.replace(` ${props.size}`, "", props.title)}</h1>
            )}
          </div>
        </div>
        <div className="product__main">
          {props.freeSample && (
            <Link
              className="product__request-sample"
              to={`/${brandSlug}/request-a-sample/`}
            >
              FREE Sample
            </Link>
          )}
          <div className="product__inner">
            <div
              className={`product__gallery${
                props.gallery?.length > 1 ? " has-arrows" : ""
              }`}
            >
              <BlockUpdate>
                <Slider {...settings}>
                  {props.gallery?.length > 0 &&
                    props.gallery.map((el, i) => (
                      <div className="product__image">
                        {el && <Asset asset={el} />}
                      </div>
                    ))}
                </Slider>
              </BlockUpdate>
            </div>
            <div className="product__content">
              <div
                className={`product__sku-wrapper ${
                  props.availableIn?.length === 0
                    ? "product__sku-wrapper--none"
                    : ""
                }`}
              >
                {props.availableIn?.length > 0 && (
                  <ul className="product__sizes">
                    <li>Available In</li>
                    {props.availableIn?.map((el, i) => (
                      <li key={i}>
                        <Link
                          className={`btn${
                            el.url?.permalink === props.permalink
                              ? " active"
                              : ""
                          }`}
                          to={el.url?.permalink}
                        >
                          {el.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
                {props.sku && (
                  <span className="product__sku">SKU {props.sku}</span>
                )}
              </div>
              {props.richContent?.value && (
                <div className="product__text">
                  <StructuredText data={props.richContent} />
                </div>
              )}
              {props.brand !== "sunnyside" && (
                <button
                  className="product__more"
                  onClick={() => setNutrition(!nutrition)}
                >
                  Learn More
                </button>
              )}
              <div className="product__expanders">
                <ul>
                  <li>
                    <button onClick={() => setNutrition(!nutrition)}>
                      Ingredients &amp; Nutrition{" "}
                      <span>
                        <Plus />
                      </span>
                    </button>
                  </li>
                  <li>
                    <button onClick={() => setDirections(!directions)}>
                      Directions &amp; Storage{" "}
                      <span>
                        <Plus />
                      </span>
                    </button>
                  </li>
                </ul>
                <AnimationButton
                  form={true}
                  className="product__enquire btn btn--animation"
                  onClick={() => setEnquiry(!enquiry)}
                >
                  Enquire Now
                </AnimationButton>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className={`enquiry${enquiry ? " active" : ""} ${props.brand}`}
        data-lenis-prevent
      >
        <div className="enquiry__scroll">
          <div className="enquiry__header">
            <div className="enquiry__inner">
              <h4>Enquire Now</h4>
              <button onClick={() => setEnquiry(!enquiry)}>
                <CloseCircle />
              </button>
            </div>
          </div>
          <div className="enquiry__main">
            <div className="enquiry__inner">
              <div className="enquiry__product">
                <div className="enquiry__title">
                  <h5>
                    {props.title.replace(` ${props.size}`, "", props.title)}
                  </h5>
                  {props.size && (
                    <ul className="product__sizes">
                      <li>
                        <span className="btn">{props.size}</span>
                      </li>
                    </ul>
                  )}
                </div>
                <div className="enquiry__image">
                  {props.gallery?.length > 0 && (
                    <Asset asset={props.gallery[0]} />
                  )}
                </div>
              </div>
              <div className="enquiry__content">
                {props.richContent?.value && (
                  <div className="product__text">
                    <StructuredText data={props.richContent} />
                  </div>
                )}
              </div>
              <div className="enquiry__form">
                <FormComponent form={props.form} title={props.title} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className={`enquiry${nutrition ? " active" : ""} ${props.brand}`}
        data-lenis-prevent
      >
        <div className="enquiry__scroll">
          <div className="enquiry__header">
            <div className="enquiry__inner">
              <h4>Ingredients & Nutrition</h4>
              <button onClick={() => setNutrition(!nutrition)}>
                <CloseCircle />
              </button>
            </div>
          </div>
          <div className="enquiry__main">
            <div className="enquiry__inner">
              <div className="enquiry__product">
                <div className="enquiry__title">
                  <h5>
                    {props.title.replace(` ${props.size}`, "", props.title)}
                  </h5>
                  {props.size && (
                    <ul className="product__sizes">
                      <li>
                        <span className="btn">{props.size}</span>
                      </li>
                    </ul>
                  )}
                </div>
                <div className="enquiry__image">
                  {props.gallery?.length > 0 && (
                    <Asset asset={props.gallery[0]} />
                  )}
                </div>
              </div>
              <div className="enquiry__content">
                <p>
                  <strong>Ingredients</strong>
                </p>
                {props.richContent?.value && (
                  <div className="product__text">
                    <StructuredText data={props.ingredients} />
                  </div>
                )}
              </div>
              {props.nutritionalInformation?.length > 0 && (
                <div className="enquiry__content">
                  <p>
                    <strong>Nutritional Information</strong>
                  </p>
                  <ul>
                    {props.nutritionalInformation?.map((el, i) => (
                      <li key={i}>
                        <h5>{el.label}</h5>
                        <p>{el.value}</p>
                      </li>
                    ))}
                  </ul>
                  {props.nutritionalTable?.length > 0 && (
                    <div className="enquiry__table">
                      <ul>
                        <li>
                          <h5>&nbsp;</h5>
                          <span>
                            {props.tableColumnTitleOne
                              ? props.tableColumnTitleOne
                              : "Per Serving"}
                          </span>
                          <span>
                            {props.tableColumnTitleTwo
                              ? props.tableColumnTitleTwo
                              : "Per 100g"}
                          </span>
                        </li>
                        {props.nutritionalTable?.map((el, i) => (
                          <li key={i}>
                            <h5>{el.label}</h5>
                            <span>{el.serveValue}</span>
                            <span>{el.perHundredValue}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
              {props.allergens && (
                <div className="enquiry__content">
                  <p>
                    <strong>Allergens</strong>
                  </p>
                  <p>{props.allergens}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section
        className={`enquiry${directions ? " active" : ""} ${props.brand}`}
      >
        <div className="enquiry__scroll">
          <div className="enquiry__header">
            <div className="enquiry__inner">
              <h4>Directions & Storage</h4>
              <button onClick={() => setDirections(!directions)}>
                <CloseCircle />
              </button>
            </div>
          </div>
          <div className="enquiry__main">
            <div className="enquiry__inner">
              <div className="enquiry__product">
                <div className="enquiry__title">
                  <h5>
                    {props.title.replace(` ${props.size}`, "", props.title)}
                  </h5>
                  {props.size && (
                    <ul className="product__sizes">
                      <li>
                        <span className="btn">{props.size}</span>
                      </li>
                    </ul>
                  )}
                </div>
                <div className="enquiry__image">
                  {props.gallery?.length > 0 && (
                    <Asset asset={props.gallery[0]} />
                  )}
                </div>
              </div>
              <div className="enquiry__content enquiry__directions">
                {props.directionsStorage?.length > 0 && (
                  <ul>
                    {props.directionsStorage?.map((el, i) => (
                      <li key={i}>
                        <h5>{el.label}</h5>
                        <div>
                          {el.value && <p>{el.value}</p>}
                          {el.richValue && (
                            <StructuredText
                              className="structured"
                              data={el.richValue}
                            />
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ProductContent
